export const RECEIPT_PAYMENT_METHOD_OPTIONS = [
  { value: 'cash', label: 'Cash' },
  { value: 'qr_bank', label: 'QR / Bank' },
  { value: 'payment_gateway', label: 'Payment Gateway' }
];

export function isOnlineReceiptMethod(method) {
  const m = String(method || '').trim().toLowerCase();
  return m === 'payment_gateway' || m === 'online';
}

export function receiptPaymentMethodLabel(method) {
  const hit = RECEIPT_PAYMENT_METHOD_OPTIONS.find((o) => o.value === method);
  if (hit) return hit.label;
  if (method === 'office') return 'Cash';
  if (method === 'online') return 'Payment Gateway';
  return method || '—';
}
